/* Iron & Acre — Meals Made Easy v2
   Metaobject-driven individual meal selector. No bundle products or new discounts. */
(function () {
  'use strict';

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function bool(value) {
    return value === true || value === 'true';
  }

  function formatMoney(cents, currency) {
    var value = toNumber(cents, 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(value % 1 === 0 ? 0 : 2);
    }
  }

  var WEEK_STORAGE_KEY = 'ia_mme_week_v2';
  var WEEK_STORAGE_HOURS = 24;

  function safeJson(value, fallback) {
    try { return JSON.parse(value); }
    catch (error) { return fallback; }
  }

  function freshWeekState() {
    return {
      expiresAt: Date.now() + WEEK_STORAGE_HOURS * 60 * 60 * 1000,
      buildId: 'week-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8),
      meals: [],
      items: {},
      approvals: {},
      mode: 'one_time'
    };
  }

  function readWeekState() {
    var saved = null;
    try { saved = safeJson(window.localStorage.getItem(WEEK_STORAGE_KEY), null); }
    catch (error) {}
    if (!saved || toNumber(saved.expiresAt, 0) < Date.now() || !Array.isArray(saved.meals)) return freshWeekState();
    var seenMeals = {};
    saved.meals = saved.meals.map(function (mealId) { return String(mealId || '').trim(); }).filter(function (mealId) {
      if (!mealId || seenMeals[mealId]) return false;
      seenMeals[mealId] = true;
      return true;
    });
    saved.items = saved.items && typeof saved.items === 'object' ? saved.items : {};
    saved.approvals = saved.approvals && typeof saved.approvals === 'object' ? saved.approvals : {};
    saved.mode = saved.mode || 'one_time';
    saved.buildId = saved.buildId || freshWeekState().buildId;
    return saved;
  }

  function writeWeekState(state) {
    state.expiresAt = Date.now() + WEEK_STORAGE_HOURS * 60 * 60 * 1000;
    try { window.localStorage.setItem(WEEK_STORAGE_KEY, JSON.stringify(state)); }
    catch (error) {}
    document.dispatchEvent(new CustomEvent('ia_mme_week_state_changed', { detail: state }));
    return state;
  }

  function weekItemKey(mealId, item) {
    return [mealId || '', item.dataset.productHandle || item.dataset.variantId || '0', item.dataset.choiceGroup || '', item.dataset.role || ''].join('|');
  }

  function captureControllerItems(controller, state) {
    if (!controller || !state) return state;
    controller.items.forEach(function (item) {
      var variant = controller.variantFor(item);
      state.items[weekItemKey(controller.bundleId, item)] = {
        selected: controller.isSelected(item),
        quantity: controller.quantityFor(item),
        variantId: variant.id
      };
    });
    return state;
  }

  function syncControllerToWeek(controller) {
    if (!controller || !controller.bundleId) return;
    var state = readWeekState();
    if (state.meals.indexOf(controller.bundleId) === -1) return;
    captureControllerItems(controller, state);
    state.approvals = {};
    writeWeekState(state);
  }

  function dispatchAnalytics(name, detail) {
    var payload = Object.assign({ event: name, version: 2 }, detail || {});
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function cartSections(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function publishCartUpdate(variantId, cartData) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      return Promise.resolve(window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'ia-meals-made-easy-v2',
        productVariantId: String(variantId || ''),
        variantId: String(variantId || ''),
        cartData: cartData
      }));
    }
    return Promise.resolve();
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var data = {};
      try { data = text ? JSON.parse(text) : {}; }
      catch (error) { data = { description: text || 'The cart returned an unreadable response.' }; }
      return { response: response, data: data };
    });
  }

  function fetchCart() {
    return fetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read the current cart.');
      return response.json();
    });
  }

  function privateProperty(item, key) {
    return item && item.properties ? item.properties[key] || '' : '';
  }

  function lineSignature(item) {
    var sellingPlanId = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      sellingPlanId = String(item.selling_plan_allocation.selling_plan.id || '');
    } else if (item.selling_plan) {
      sellingPlanId = String(item.selling_plan);
    }
    return [
      String(item.variant_id || item.id || ''),
      sellingPlanId,
      privateProperty(item, '_ia_meal_bundle_id'),
      privateProperty(item, '_ia_meal_bundle_role')
    ].join('|');
  }

  function requestSignature(item) {
    return [
      String(item.id || ''),
      item.selling_plan ? String(item.selling_plan) : '',
      item.properties ? String(item.properties._ia_meal_bundle_id || '') : '',
      item.properties ? String(item.properties._ia_meal_bundle_role || '') : ''
    ].join('|');
  }

  function cartQuantities(cart) {
    var quantities = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var key = lineSignature(item);
      quantities[key] = (quantities[key] || 0) + toNumber(item.quantity, 0);
    });
    return quantities;
  }

  function refreshDrawerSections(drawer, sections) {
    if (!drawer || typeof drawer.renderContents !== 'function') return Promise.resolve(null);
    var path = window.location.pathname || '/';
    var separator = path.indexOf('?') === -1 ? '?' : '&';
    return fetch(path + separator + 'sections=' + encodeURIComponent(sections.join(',')), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart sections.');
        return response.json();
      })
      .then(function (sectionData) {
        var contents = { sections: sectionData };
        drawer.classList.remove('is-empty');
        drawer.renderContents(contents);
        return contents;
      });
  }

  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function MealV2Controller(root) {
    this.root = root;
    this.bundleId = root.dataset.bundleId || '';
    this.bundleName = root.dataset.bundleName || '';
    this.bundleUrl = root.dataset.bundleUrl || window.location.pathname;
    this.placement = root.dataset.placement || 'detail_v2';
    this.currency = root.dataset.currency || 'USD';
    this.ctaLabel = root.dataset.ctaLabel || 'Add Selected Groceries';
    this.orderMinimum = toNumber(root.dataset.orderMinimum, 10000);
    this.deliveryThreshold = toNumber(root.dataset.deliveryThreshold, 15000);
    this.defaultServings = toNumber(root.dataset.defaultServings, 1);
    this.servingsCap = toNumber(root.dataset.servingsCap, 24);
    this.servingsNodes = Array.prototype.slice.call(root.querySelectorAll('[data-mme-v2-servings]'));
    this.enableSubscription = bool(root.dataset.enableSubscription);
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-mme-v2-item]'));
    this.totalElement = root.querySelector('[data-mme-v2-total]');
    this.perPersonElement = root.querySelector('[data-mme-v2-per-person]');
    this.countElement = root.querySelector('[data-mme-v2-count]');
    this.summaryLines = root.querySelector('[data-mme-v2-summary-lines]');
    this.primaryButton = root.querySelector('[data-mme-v2-add="complete"]');
    this.partialButton = root.querySelector('[data-mme-v2-add="available"]');
    this.notice = root.querySelector('[data-mme-v2-notice]');
    this.liveRegion = root.querySelector('[data-mme-v2-live]');
    this.subscriptionWrap = root.querySelector('[data-mme-v2-subscription-wrap]');
    this.subscriptionInput = root.querySelector('[data-mme-v2-subscription]');
    this.mobileSummary = root.querySelector('[data-mme-v2-mobile-summary]');
    this.mobileTotal = root.querySelector('[data-mme-v2-mobile-total]');
    this.mobileCount = root.querySelector('[data-mme-v2-mobile-count]');
    this.pending = false;
    this.lastTotal = 0;
    this.thresholdReached = { minimum: false, delivery: false };
    this.restoreWeekSelection();
    this.bind();
    this.update('initial');
    this.observeView();
  }

  MealV2Controller.prototype.restoreWeekSelection = function () {
    if (!this.bundleId) return;
    var state = readWeekState();
    if (state.meals.indexOf(this.bundleId) === -1) return;
    var controller = this;
    this.items.forEach(function (item) {
      var key = weekItemKey(controller.bundleId, item);
      var legacyKey = [controller.bundleId, item.dataset.variantId || '0', item.dataset.choiceGroup || '', item.dataset.role || ''].join('|');
      var record = state.items[key] || state.items[legacyKey];
      if (!record) return;
      var select = item.querySelector('[data-mme-v2-variant-select]');
      if (select && record.variantId && Array.prototype.some.call(select.options, function (option) { return option.value === String(record.variantId) && !option.disabled; })) {
        select.value = String(record.variantId);
      }
      var input = item.querySelector('[data-mme-v2-choice],[data-mme-v2-toggle]');
      if (input && !input.disabled) input.checked = Boolean(record.selected);
      item.dataset.quantity = String(Math.max(1, toNumber(record.quantity, 1)));
      var output = item.querySelector('[data-mme-v2-quantity-output]');
      if (output) output.textContent = item.dataset.quantity;
    });
  };

  MealV2Controller.prototype.bind = function () {
    var controller = this;
    this.root.addEventListener('change', function (event) {
      var control = event.target;
      if (!control.matches('[data-mme-v2-choice], [data-mme-v2-toggle], [data-mme-v2-variant-select], [data-mme-v2-subscription]')) return;
      var item = control.closest('[data-mme-v2-item]');
      var before = controller.lastTotal;
      var state = controller.update('change');
      syncControllerToWeek(controller);
      var action = 'selection_changed';
      if (control.matches('[data-mme-v2-subscription]')) action = control.checked ? 'recurring_selected' : 'one_time_selected';
      else if (control.matches('[data-mme-v2-toggle]')) action = control.checked ? 'item_selected' : 'item_removed';
      else if (control.matches('[data-mme-v2-choice]')) action = 'choice_selected';
      else if (control.matches('[data-mme-v2-variant-select]')) action = 'variant_selected';
      var itemDetail = {
        meal_id: controller.bundleId,
        meal_name: controller.bundleName,
        placement: controller.placement,
        role: item ? item.dataset.role || '' : 'Recurring delivery',
        product_handle: item ? item.dataset.productHandle || '' : '',
        action: action,
        prior_value_cents: before,
        current_value_cents: state.total,
        purchase_mode: controller.subscriptionInput && controller.subscriptionInput.checked ? 'recurring' : 'one_time'
      };
      dispatchAnalytics('ia_mme_item_toggle', itemDetail);
      if (item && (item.dataset.behavior === 'choice' || item.dataset.behavior === 'no_item_choice')) {
        dispatchAnalytics('ia_mme_alternative_choice', itemDetail);
      }
      if (item && item.dataset.behavior === 'optional') {
        dispatchAnalytics('ia_mme_optional_addition', itemDetail);
      }
      dispatchAnalytics('ia_meal_bundle_selection_changed', {
        bundle_id: controller.bundleId,
        bundle_name: controller.bundleName,
        placement: controller.placement,
        role: item ? item.dataset.role || '' : 'Recurring delivery',
        action: action,
        prior_value_cents: before,
        current_value_cents: state.total
      });
    });

    this.root.addEventListener('click', function (event) {
      var increase = event.target.closest('[data-mme-v2-quantity-increase]');
      var decrease = event.target.closest('[data-mme-v2-quantity-decrease]');
      if (increase || decrease) {
        var item = event.target.closest('[data-mme-v2-item]');
        if (!item) return;
        var prior = controller.quantityFor(item);
        var maximum = Math.max(1, toNumber(item.dataset.maxQuantity, 1));
        var next = increase ? Math.min(maximum, prior + 1) : Math.max(1, prior - 1);
        if (next === prior) return;
        item.dataset.quantity = String(next);
        var output = item.querySelector('[data-mme-v2-quantity-output]');
        if (output) output.textContent = String(next);
        var state = controller.update('quantity');
        syncControllerToWeek(controller);
        dispatchAnalytics('ia_mme_quantity_changed', {
          meal_id: controller.bundleId,
          meal_name: controller.bundleName,
          role: item.dataset.role || '',
          product_handle: item.dataset.productHandle || '',
          prior_quantity: prior,
          quantity: next,
          current_value_cents: state.total
        });
        return;
      }
      if (event.target.closest('[data-mme-v2-select-recommended]')) {
        controller.selectRecommended();
        var recommendedState = controller.update('recommended');
        syncControllerToWeek(controller);
        dispatchAnalytics('ia_mme_select_all_recommended', {
          meal_id: controller.bundleId,
          meal_name: controller.bundleName,
          selected_value_cents: recommendedState.total,
          item_count: recommendedState.cartSelections.length
        });
        return;
      }
      if (event.target.closest('[data-mme-v2-scroll-summary]')) {
        var summary = controller.root.querySelector('.ia-mme-v2-purchase');
        if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    if (this.primaryButton) this.primaryButton.addEventListener('click', function () { controller.add('complete'); });
    if (this.partialButton) this.partialButton.addEventListener('click', function () { controller.add('available'); });
    var recipeLink = this.root.querySelector('[data-mme-v2-recipe-link]');
    if (recipeLink) recipeLink.addEventListener('click', function () {
      dispatchAnalytics('ia_mme_recipe_link_click', { meal_id: controller.bundleId, placement: controller.placement });
    });
  };

  MealV2Controller.prototype.observeView = function () {
    var controller = this;
    var tracked = false;
    var track = function () {
      if (tracked) return;
      tracked = true;
      var state = controller.selectionState();
      var detail = { meal_id: controller.bundleId, meal_name: controller.bundleName, placement: controller.placement, selected_value_cents: state.total, item_count: state.cartSelections.length };
      dispatchAnalytics('ia_mme_meal_view', detail);
      dispatchAnalytics('ia_meal_bundle_view', { bundle_id: controller.bundleId, bundle_name: controller.bundleName, placement: controller.placement, selected_value_cents: state.total, item_count: state.cartSelections.length });
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { track(); observer.disconnect(); }
      }, { threshold: 0.2 });
      observer.observe(this.root);
    } else track();
  };

  MealV2Controller.prototype.quantityFor = function (item) {
    return Math.max(1, toNumber(item.dataset.quantity, 1));
  };

  MealV2Controller.prototype.isSelected = function (item) {
    var behavior = item.dataset.behavior || 'recommended';
    if (behavior === 'choice' || behavior === 'no_item_choice') {
      var radio = item.querySelector('[data-mme-v2-choice]');
      return Boolean(radio && radio.checked);
    }
    var toggle = item.querySelector('[data-mme-v2-toggle]');
    return Boolean(toggle && toggle.checked);
  };

  MealV2Controller.prototype.variantFor = function (item) {
    var select = item.querySelector('[data-mme-v2-variant-select]');
    var option = selectedOption(select);
    var source = option || item;
    return {
      id: toNumber(source.dataset.variantId || (option ? option.value : ''), 0),
      title: source.dataset.variantTitle || '',
      price: toNumber(source.dataset.price, 0),
      available: bool(source.dataset.available),
      sellingPlanId: toNumber(source.dataset.sellingPlanId, 0),
      sellingPlanPrice: toNumber(source.dataset.sellingPlanPrice, 0)
    };
  };

  MealV2Controller.prototype.displayTitle = function (item, variant) {
    var productTitle = item.dataset.productTitle || item.dataset.role || 'Grocery';
    var variantTitle = variant && variant.title ? variant.title.trim() : '';
    if (variantTitle && variantTitle.toLowerCase() !== 'default title') return productTitle + ' — ' + variantTitle;
    return productTitle;
  };

  MealV2Controller.prototype.selectRecommended = function () {
    var groupsHandled = {};
    this.items.forEach(function (item) {
      var behavior = item.dataset.behavior || 'recommended';
      if (behavior === 'recommended') {
        var toggle = item.querySelector('[data-mme-v2-toggle]');
        if (toggle && !toggle.disabled) toggle.checked = true;
      }
      if (behavior === 'choice' || behavior === 'no_item_choice') {
        var group = item.dataset.choiceGroup || '';
        if (groupsHandled[group]) return;
        var preferred = item.parentNode.querySelector('[data-mme-v2-item][data-choice-group="' + CSS.escape(group) + '"][data-default-selected="true"] [data-mme-v2-choice]');
        if (preferred && !preferred.disabled) preferred.checked = true;
        groupsHandled[group] = true;
      }
    });
  };

  MealV2Controller.prototype.selectionState = function () {
    var controller = this;
    var selections = [];
    var cartSelections = [];
    var missing = [];
    var groups = {};

    this.items.forEach(function (item) {
      var behavior = item.dataset.behavior || 'recommended';
      var group = item.dataset.choiceGroup || '';
      var variant = controller.variantFor(item);
      var selected = controller.isSelected(item);
      var noItem = behavior === 'no_item_choice' || !variant.id;
      if ((behavior === 'choice' || behavior === 'no_item_choice') && group) {
        groups[group] = groups[group] || { selected: false, role: item.dataset.role || 'Choice' };
        if (selected) groups[group].selected = true;
      }
      if (behavior === 'optional' && selected && !variant.available) {
        var optional = item.querySelector('[data-mme-v2-toggle]');
        if (optional) optional.checked = false;
        selected = false;
      }
      item.classList.toggle('is-selected', selected);
      item.classList.toggle('is-unavailable', !noItem && !variant.available);
      item.setAttribute('aria-disabled', !noItem && !variant.available ? 'true' : 'false');

      var quantity = noItem ? 0 : controller.quantityFor(item);
      var price = variant.price;
      if (controller.subscriptionInput && controller.subscriptionInput.checked && variant.sellingPlanId && variant.sellingPlanPrice) price = variant.sellingPlanPrice;
      var priceElement = item.querySelector('[data-mme-v2-item-price]');
      if (priceElement) priceElement.textContent = noItem ? 'No charge' : formatMoney(price, controller.currency);

      if (selected) {
        var selection = { item: item, variant: variant, price: price, quantity: quantity, noItem: noItem, servingsYield: toNumber(item.dataset.servingsYield, 0) };
        selections.push(selection);
        if (!noItem) {
          cartSelections.push(selection);
          if (!variant.available && behavior !== 'optional') missing.push(controller.displayTitle(item, variant));
        }
      }
    });

    Object.keys(groups).forEach(function (group) {
      if (!groups[group].selected) missing.push(groups[group].role);
    });

    var recurringEligible = cartSelections.length > 0 && cartSelections.every(function (selection) {
      return selection.variant.sellingPlanId && selection.variant.sellingPlanPrice;
    });
    if (this.subscriptionWrap) this.subscriptionWrap.classList.toggle('is-visible', this.enableSubscription && recurringEligible);
    if ((!this.enableSubscription || !recurringEligible) && this.subscriptionInput && this.subscriptionInput.checked) {
      this.subscriptionInput.checked = false;
      cartSelections.forEach(function (selection) { selection.price = selection.variant.price; });
    }

    var total = cartSelections.reduce(function (sum, selection) { return sum + selection.price * selection.quantity; }, 0);
    var packageCount = cartSelections.reduce(function (sum, selection) { return sum + selection.quantity; }, 0);
    var yieldedServings = cartSelections.reduce(function (sum, selection) { return sum + selection.servingsYield * selection.quantity; }, 0);
    var servings = yieldedServings > 0 ? Math.min(yieldedServings, this.servingsCap) : this.defaultServings;
    return {
      selections: selections,
      cartSelections: cartSelections,
      missing: Array.from(new Set(missing)),
      total: total,
      packageCount: packageCount,
      servings: servings,
      recurringEligible: recurringEligible,
      availableSelections: cartSelections.filter(function (selection) { return selection.variant.available; })
    };
  };

  MealV2Controller.prototype.renderSummary = function (state) {
    var controller = this;
    if (!this.summaryLines) return;
    this.summaryLines.innerHTML = '';
    state.cartSelections.forEach(function (selection) {
      var line = document.createElement('li');
      var name = document.createElement('span');
      var price = document.createElement('strong');
      var quantityLabel = selection.quantity > 1 ? ' × ' + selection.quantity : '';
      name.textContent = controller.displayTitle(selection.item, selection.variant) + quantityLabel;
      price.textContent = formatMoney(selection.price * selection.quantity, controller.currency);
      line.appendChild(name);
      line.appendChild(price);
      controller.summaryLines.appendChild(line);
    });
  };

  MealV2Controller.prototype.renderThreshold = function (kind, total) {
    var threshold = kind === 'minimum' ? this.orderMinimum : this.deliveryThreshold;
    var row = this.root.querySelector('[data-mme-v2-threshold="' + kind + '"]');
    if (!row || !threshold) return;
    var gap = Math.max(0, threshold - total);
    var progress = Math.min(100, (total / threshold) * 100);
    var text = row.querySelector('[data-mme-v2-threshold-text]');
    var bar = row.querySelector('[data-mme-v2-threshold-bar]');
    row.classList.toggle('is-reached', gap === 0);
    if (text) text.textContent = gap === 0 ? (kind === 'minimum' ? 'Minimum reached' : 'Complimentary delivery reached') : formatMoney(gap, this.currency) + ' to go';
    if (bar) bar.style.width = progress + '%';
    if (gap === 0 && !this.thresholdReached[kind]) {
      this.thresholdReached[kind] = true;
      dispatchAnalytics('ia_mme_threshold_reached', { meal_id: this.bundleId, threshold: kind, threshold_cents: threshold, selected_value_cents: total });
    }
    if (gap > 0) this.thresholdReached[kind] = false;
  };

  MealV2Controller.prototype.update = function () {
    var state = this.selectionState();
    this.lastTotal = state.total;
    if (this.totalElement) this.totalElement.textContent = formatMoney(state.total, this.currency);
    if (this.perPersonElement) this.perPersonElement.textContent = 'Serves ' + state.servings + ' · About ' + formatMoney(Math.round(state.total / Math.max(1, state.servings)), this.currency) + ' per person';
    if (this.countElement) this.countElement.textContent = state.packageCount + (state.packageCount === 1 ? ' package' : ' packages') + ' across ' + state.cartSelections.length + (state.cartSelections.length === 1 ? ' product' : ' products');
    if (this.mobileTotal) this.mobileTotal.textContent = formatMoney(state.total, this.currency);
    if (this.mobileCount) this.mobileCount.textContent = state.packageCount + (state.packageCount === 1 ? ' package' : ' packages') + ' selected';
    this.servingsNodes.forEach(function (node) { node.textContent = String(state.servings); });
    this.renderSummary(state);
    this.renderThreshold('minimum', state.total);
    this.renderThreshold('delivery', state.total);

    var hasMissing = state.missing.length > 0;
    if (this.notice) {
      if (hasMissing) {
        this.notice.classList.add('is-visible');
        this.notice.dataset.status = 'availability';
        this.notice.textContent = 'Your selection needs: ' + state.missing.join(', ') + '. Choose an available option or add the available groceries only.';
      } else if (!this.notice.dataset.status || this.notice.dataset.status === 'availability') {
        this.notice.classList.remove('is-visible');
        this.notice.textContent = '';
        delete this.notice.dataset.status;
      }
    }
    if (this.primaryButton) {
      this.primaryButton.disabled = this.pending || hasMissing || state.cartSelections.length === 0;
      this.primaryButton.textContent = this.pending ? 'Adding…' : this.ctaLabel + ' · ' + formatMoney(state.total, this.currency);
    }
    if (this.partialButton) {
      var showPartial = hasMissing && state.availableSelections.length > 0;
      this.partialButton.classList.toggle('is-visible', showPartial);
      this.partialButton.disabled = this.pending || !showPartial;
      this.partialButton.textContent = 'Add ' + state.availableSelections.length + ' available ' + (state.availableSelections.length === 1 ? 'product' : 'products');
    }
    if (this.mobileSummary) this.mobileSummary.classList.toggle('is-visible', state.cartSelections.length > 0);
    return state;
  };

  MealV2Controller.prototype.requestItems = function (mode) {
    var controller = this;
    var state = this.selectionState();
    var selections = mode === 'available' ? state.availableSelections : state.cartSelections;
    return selections.map(function (selection) {
      var item = {
        id: selection.variant.id,
        quantity: selection.quantity,
        properties: {
          _ia_meal_bundle_id: controller.bundleId,
          _ia_meal_bundle_name: controller.bundleName,
          _ia_meal_bundle_role: selection.item.dataset.role || 'Grocery',
          _ia_meal_product_title: controller.displayTitle(selection.item, selection.variant),
          _ia_meal_source: 'individual_meal',
          _ia_mme_meal_ids: JSON.stringify([controller.bundleId])
        }
      };
      if (controller.subscriptionInput && controller.subscriptionInput.checked && selection.variant.sellingPlanId) item.selling_plan = selection.variant.sellingPlanId;
      return item;
    });
  };

  MealV2Controller.prototype.setPending = function (pending) {
    this.pending = pending;
    this.root.classList.toggle('is-pending', pending);
    this.update();
  };

  MealV2Controller.prototype.showNotice = function (message, isError) {
    if (!this.notice) return;
    this.notice.textContent = message;
    this.notice.classList.add('is-visible');
    this.notice.dataset.status = isError ? 'error' : 'success';
  };

  MealV2Controller.prototype.announce = function (message) {
    if (this.liveRegion) this.liveRegion.textContent = message;
  };

  MealV2Controller.prototype.reconcile = function (beforeCart, afterCart, requestItems) {
    var before = cartQuantities(beforeCart);
    var after = cartQuantities(afterCart);
    var added = [];
    var missing = [];
    requestItems.forEach(function (item) {
      var delta = (after[requestSignature(item)] || 0) - (before[requestSignature(item)] || 0);
      var customerTitle = item.properties._ia_meal_product_title || item.properties._ia_meal_bundle_role || 'Selected product';
      if (delta >= item.quantity) added.push(customerTitle);
      else missing.push(customerTitle);
    });
    return { added: added, missing: missing };
  };

  MealV2Controller.prototype.renderCart = function (data, drawer, sections, firstVariantId) {
    return publishCartUpdate(firstVariantId, data).then(function () {
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        return data;
      }
      return refreshDrawerSections(drawer, sections).then(function () { return data; });
    }).catch(function () { return refreshDrawerSections(drawer, sections).then(function () { return data; }); });
  };

  MealV2Controller.prototype.add = function (mode) {
    var controller = this;
    if (this.pending) return;
    var state = this.update();
    if (mode === 'complete' && state.missing.length) return;
    var items = this.requestItems(mode);
    if (!items.length) return;
    var drawer = cartDrawer();
    var sections = cartSections(drawer);
    var addUrl = (window.routes && window.routes.cart_add_url) || (ROOT_URL + 'cart/add.js');
    var selectedValue = items.reduce(function (sum, item) {
      var selection = state.cartSelections.find(function (candidate) { return candidate.variant.id === item.id; });
      return sum + (selection ? selection.price * item.quantity : 0);
    }, 0);
    var purchaseMode = this.subscriptionInput && this.subscriptionInput.checked ? 'recurring' : 'one_time';

    dispatchAnalytics('ia_mme_add_started', { meal_id: this.bundleId, meal_name: this.bundleName, add_mode: mode, purchase_mode: purchaseMode, item_count: items.length, selected_value_cents: selectedValue });
    dispatchAnalytics('ia_meal_bundle_add_started', { bundle_id: this.bundleId, bundle_name: this.bundleName, placement: this.placement, add_mode: mode, item_count: items.length, selected_value_cents: selectedValue, subscription_count: purchaseMode === 'recurring' ? items.length : 0 });

    this.setPending(true);
    if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    var beforeCart;
    fetchCart()
      .then(function (cart) {
        beforeCart = cart;
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        });
      })
      .then(parseJsonResponse)
      .then(function (result) {
        if (!result.response.ok || result.data.status) {
          var error = new Error(result.data.description || result.data.message || 'The selected groceries could not be added.');
          error.cartData = result.data;
          throw error;
        }
        return controller.renderCart(result.data, drawer, sections, items[0].id).then(function () {
          var message = items.length + (items.length === 1 ? ' product added to your cart.' : ' products added to your cart.');
          controller.showNotice(message, false);
          controller.announce(message);
          dispatchAnalytics('ia_mme_add_to_cart', { meal_id: controller.bundleId, meal_name: controller.bundleName, status: 'complete', add_mode: mode, purchase_mode: purchaseMode, added_item_count: items.length, added_value_cents: selectedValue, order_minimum_reached: selectedValue >= controller.orderMinimum, complimentary_delivery_reached: selectedValue >= controller.deliveryThreshold });
          dispatchAnalytics('ia_meal_bundle_add_to_cart', { bundle_id: controller.bundleId, bundle_name: controller.bundleName, placement: controller.placement, status: 'complete', add_mode: mode, added_item_count: items.length, added_value_cents: selectedValue });
        });
      })
      .catch(function (error) {
        return fetchCart().then(function (afterCart) {
          var reconciled = controller.reconcile(beforeCart || { items: [] }, afterCart, items);
          if (reconciled.added.length) {
            return refreshDrawerSections(drawer, sections).catch(function () { return null; }).then(function () {
              var partial = 'Added ' + reconciled.added.length + (reconciled.added.length === 1 ? ' product' : ' products') + '. Could not add: ' + reconciled.missing.join(', ') + '.';
              controller.showNotice(partial, true);
              controller.announce(partial);
              dispatchAnalytics('ia_mme_add_to_cart', { meal_id: controller.bundleId, status: 'partial', added_item_count: reconciled.added.length, missing_roles: reconciled.missing });
            });
          }
          controller.showNotice(error.message || 'The selected groceries could not be added.', true);
          controller.announce('The selected groceries could not be added.');
          dispatchAnalytics('ia_mme_add_failed', { meal_id: controller.bundleId, failure_type: 'cart_error', message: String(error.message || '').slice(0, 180) });
        }).catch(function () {
          controller.showNotice(error.message || 'The selected groceries could not be added.', true);
          controller.announce('The selected groceries could not be added.');
        });
      })
      .finally(function () { controller.setPending(false); });
  };

  var popupSuppressionTimers = [];

  function hideKlaviyoNode(node) {
    if (!node) return;
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
    var ancestor = node.parentElement;
    var depth = 0;
    while (ancestor && ancestor !== document.body && depth < 7) {
      var style = window.getComputedStyle(ancestor);
      if (style.position === 'fixed') {
        ancestor.setAttribute('aria-hidden', 'true');
        ancestor.style.setProperty('display', 'none', 'important');
        break;
      }
      ancestor = ancestor.parentElement;
      depth += 1;
    }
  }

  function suppressMealPopupsNow() {
    document.querySelectorAll('.klaviyo-form, [class*="kl-teaser-"]').forEach(hideKlaviyoNode);
  }

  function suppressMealPopups() {
    if (!document.querySelector('[data-mme-popup-scope]')) return;
    document.documentElement.classList.add('ia-mme-popup-suppressed');
    popupSuppressionTimers.forEach(function (timer) { window.clearTimeout(timer); });
    popupSuppressionTimers = [0, 250, 750, 1500, 3000, 6000].map(function (delay) {
      return window.setTimeout(suppressMealPopupsNow, delay);
    });
    window.addEventListener('klaviyoForms', suppressMealPopupsNow);
  }

  function initializeWeekHandoff() {
    var controls = Array.prototype.slice.call(document.querySelectorAll('[data-mme-start-week]'));
    if (!controls.length) return;

    controls.forEach(function (control) {
      if (control.dataset.mmeWeekBound === 'true') return;
      control.dataset.mmeWeekBound = 'true';
      control.addEventListener('click', function (event) {
        event.preventDefault();
        if (control.dataset.mmeWeekBusy === 'true') return;
        control.dataset.mmeWeekBusy = 'true';
        var mealId = String(control.dataset.mealId || '').trim();
        if (!mealId) {
          delete control.dataset.mmeWeekBusy;
          return;
        }
        var state = readWeekState();
        if (state.meals.indexOf(mealId) === -1) state.meals.push(mealId);
        var root = control.closest('[data-mme-v2-controller]');
        if (root && root.__iaMmeV2) captureControllerItems(root.__iaMmeV2, state);
        state.approvals = {};
        writeWeekState(state);
        dispatchAnalytics('ia_mme_week_handoff', {
          source: root ? 'individual_meal' : 'meals_landing',
          meal_id: mealId,
          meal_count: state.meals.length
        });
        var destination = control.getAttribute('href') || control.dataset.weekUrl || (ROOT_URL + 'pages/meals-made-easy');
        var target = new URL(destination, window.location.origin);
        target.searchParams.set('meal', mealId);
        window.location.assign(target.pathname + target.search + target.hash);
      });
    });
  }

  function initialize() {
    suppressMealPopups();
    document.querySelectorAll('[data-mme-v2-controller]').forEach(function (root) {
      if (root.dataset.mmeV2Ready === 'true') return;
      root.dataset.mmeV2Ready = 'true';
      root.__iaMmeV2 = new MealV2Controller(root);
    });
    initializeWeekHandoff();
    document.querySelectorAll('[data-mme-v2-meal-link]').forEach(function (link) {
      if (link.dataset.mmeV2Tracked === 'true') return;
      link.dataset.mmeV2Tracked = 'true';
      link.addEventListener('click', function () {
        dispatchAnalytics('ia_mme_meal_card_click', { meal_id: link.dataset.mealId || '', placement: link.dataset.placement || 'related' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
